import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { getRegionNames, clearQueue, getCurrentQueueLength, getRequestTypeOptions } from "../components/Requests/Requests";
import {
    StandardScreen,
    StandardSearchBox,
    StandardCheckbox,
    StandardDropdown,
    StandardButton,
    StatusMessage,
    FormRow,
    StandardTextField
} from '../components/Layout';
import Theme from '../styles/theme.js';
import { FormLabel, PageLayout } from '../components/Layout/BaseComponents.jsx';

class ClearQueue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingClearing: false,
            error: "",
            spHostUrl: "",
            message: "",
            applySpecificRequestType: false,
            regionNameChosen: "",
            regionNames: "",
            requestType: null,
            requestTypeOptions: [],
            reason: "",
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getRegionNames();
    }

    onSPHostUrlChange = (newValue) => {
        this.setState({
            spHostUrl: newValue,
            message: "",
            error: ""
        });
    };

    onSelectRegionName = (event, item) => {
        this.setState({
            regionNameChosen: item.key,
            message: "",
            error: ""
        });
        this.getRequestTypeOptions(item.key);
    };

    onCheckSpecificRequestType = (event, checked) => {
        this.setState({
            applySpecificRequestType: checked,
            requestType: null,
            message: "",
            error: ""
        });
    };

    onRequestTypeChange = (event, item) => {
        this.setState({
            requestType: item.key,
            message: "",
            error: ""
        });
    };

    async clearQueue(requestBody) {
        this.setState({ loadingClearing: true, message: "" });
        let response = await clearQueue(this.props.accessToken, requestBody);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({ error: "", message: data.message, loadingClearing: false });
        } else if (response.status === 401) {
            this.setState({ loadingClearing: false, error: "You are not permitted to use this feature. You must request admin permissions", message: "" });
        }
        else {
            this.setState({ loadingClearing: false, error: "Something went wrong, please check the queue length again and proceed by clicking 'Clear'", message: "" });
        };
    }

    async getCurrentQueueLength() {
        this.setState({ loading: true, message: "", error: "" })
        let requestBody = {};
        if (this.state.applySpecificRequestType) {
            requestBody = {
                spHostUrl: this.state.spHostUrl,
                requestType: this.state.requestType,
                regionName: this.state.regionNameChosen
            };
        } else {
            requestBody = {
                spHostUrl: this.state.spHostUrl,
                regionName: this.state.regionNameChosen
            };
        }
        let response = await getCurrentQueueLength(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({ loading: false, message: data.message })
        }
        else if (response.status === 404) {
            this.setState({ loading: false, message: data.message })
        }
        else {
            this.setState({ loading: false, error: "Something went wrong" });
        }
    }

    async getRegionNames() {
        this.setState({ loading: true })
        let response = await getRegionNames(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                regionNames: data.map(item =>
                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    async getRequestTypeOptions(regionNameChosen) {
        let requestBody = {
            SPHostUrl: this.state.spHostUrl,
            RegionName: regionNameChosen,
        };

        try {
            let response = await getRequestTypeOptions(this.props.accessToken, requestBody);
            if (response.ok) {
                let data = await response.json();
                this.setState({
                    loading: false,
                    requestTypeOptions: data.map(item => ({ key: item.enum, text: item.enum + ' - ' + item.enumValue })),
                });
            } else {
                console.error('Failed to fetch request type options:', response.statusText);
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching request type options:', error);
            this.setState({ loading: false });
        }
    }

    constructAndSendRequest() {
        let requestBody = {};

        if (this.state.applySpecificRequestType) {
            requestBody = {
                spHostUrl: this.state.spHostUrl,
                requestType: this.state.requestType,
                regionName: this.state.regionNameChosen,
                reason: this.state.reason,
            };
        } else {
            requestBody = {
                spHostUrl: this.state.spHostUrl,
                regionName: this.state.regionNameChosen,
                reason: this.state.reason,
            };
        }
        this.clearQueue(requestBody);
    }

    render() {
        const {
            loading,
            loadingClearing,
            error,
            spHostUrl,
            message,
            applySpecificRequestType,
            regionNameChosen,
            regionNames,
            requestType,
            requestTypeOptions,
            reason,
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title="Clear Queue"
                    description="Clear the queue for a specific SPHostUrl. This is an admin only feature."
                    loading={loading || loadingClearing}
                    loadingLabel={
                        loadingClearing ? (
                            <>
                                <span style={{ fontSize: Theme.typography.fontSize.large}}>
                                    <strong>Clearing Queue...</strong>
                                </span>

                                <br/>

                                <span style={{ fontSize: Theme.typography.fontSize.large, color: Theme.colors.text }}>
                                    This may take several minutes.
                                </span>

                                <br />
                            </>
                        ) : (
                            <>
                                <span style={{ fontSize: Theme.typography.fontSize.large}}>
                                    <strong>Loading...</strong>
                                </span>

                                <br/>

                                <span style={{ fontSize: Theme.typography.fontSize.large }}>
                                    Fetching data from the server.
                                </span>
                            </>
                        )
                    }
                >
                    <FormRow>
                        <FormLabel style={{
                            color: Theme.colors.text,
                            width: '400px',
                            fontSize: Theme.typography.fontSize.medium,
                            fontWeight: Theme.typography.fontWeight.normal,
                            marginBottom: Theme.spacing.xs,
                            fontFamily: Theme.typography.fontFamily,
                            textTransform: 'none'
                        }}>
                            Description of all request types can be found{' '}
                            <a
                                href="https://dev.azure.com/repstor/Collaborate/_wiki/wikis/Collaborate%20Wiki/1894/Request-Type-Ids"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                here
                            </a>
                        </FormLabel>
                    </FormRow>

                    <StandardSearchBox
                        label="SPHostUrl"
                        placeholder="SPHostUrl"
                        value={spHostUrl}
                        onChange={this.onSPHostUrlChange}
                    >
                    </StandardSearchBox>

                    <StandardDropdown
                        label="Environment"
                        selectedKey={regionNameChosen}
                        onChange={this.onSelectRegionName}
                        placeholder="Select Environment"
                        options={regionNames}
                        disabled={!regionNames || regionNames.length === 0}
                    >
                    </StandardDropdown>

                    <StandardCheckbox
                        label="Clear for specific request type"
                        checked={applySpecificRequestType}
                        onChange={this.onCheckSpecificRequestType}
                    />

                    <StandardDropdown
                        label="Request Type"
                        selectedKey={requestType}
                        onChange={this.onRequestTypeChange}
                        placeholder="Request Type"
                        options={requestTypeOptions || []}
                        disabled={!applySpecificRequestType}
                    >
                    </StandardDropdown>

                    <StandardTextField
                        label="Reason"
                        placeholder="Provide a reason for making this change"
                        value={this.state.reason}
                        onChange={(event, newValue) => this.setState({ reason: newValue })}
                        disabled={spHostUrl == "" || !regionNames || regionNames.length === 0 || regionNameChosen == ""}
                    >
                    </StandardTextField>

                    <div style={{ display: 'flex', gap: '20px' }}>
                        <StandardButton
                            text="Check Length"
                            onClick={() => this.getCurrentQueueLength()}
                            disabled={!spHostUrl || !regionNameChosen}
                            size="wide"
                        />

                        <StandardButton
                            text="Clear Queue"
                            onClick={() => this.constructAndSendRequest()}
                            disabled={!spHostUrl || !regionNameChosen || !message || reason == ""}
                            size="wide"
                        />
                    </div>

                    {error && (
                        <StatusMessage type="error">{error}</StatusMessage>
                    )}

                    {message && (
                        <StatusMessage type="success">{message}</StatusMessage>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default ClearQueue;
